/**
 * Project : workspace
 * File    : BusinessInvoiceListScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.invoice.list


import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.invoice.viewModel.InvoiceViewModel
import component.input.SearchBar
import component.loader.AppLoader
import component.navigation.TopNavBar
import navigation.AppNavigator
import navigation.route.invoice.InvoiceNavRoute
import presentation.screens.business.invoice.component.InvoiceCard
import theme.ThemeColor

/**
 * Represents the business invoice list screen class.
 */

class BusinessInvoiceListScreen {
    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        val viewModel = InvoiceViewModel(myBusiness.value)
        val searchQuery = viewModel.searchQuery.collectAsState()
        val allInvoice = viewModel.allCustomerInvoice.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.fetchAllInvoice{
                print(it)
            }
        }
        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = "Invoices", onBackPress = {
                AppNavigator.shared().goBack()
            },
//                onClickAdd = {
////                AppNavigator.shared().navigate(CustomerNavRoute.CREATE)
//            }
            )

            AppLoader(viewModel)
            SearchBar(
                viewModel,
                searchQuery.value,
                "Search Invoice"
            )
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 400.dp),
                modifier = Modifier.fillMaxSize()
            ) {
                items(count = allInvoice.value.count()) { index ->
                    InvoiceCard(allInvoice.value[index]) {
                        viewModel.setSelectedInvoice(it)
                        AppNavigator.shared().navigate(InvoiceNavRoute.DETAILS)
                    }
                }
            }
        }
    }
}